<div class="w-100 h-100 d-flex flex-column" style="flex: 1">
  <router-outlet></router-outlet>
</div>
<nida-web-call-handler-popup-content></nida-web-call-handler-popup-content>
<nida-web-mqtt-status-handler></nida-web-mqtt-status-handler>
